module.exports = __webpack_public_path__ + "img/hotelFamily-1.cae76ee2.jpg";